import './index.scss'
import {Carousel} from 'primereact/carousel'
import axios from 'axios'
import {useEffect, useState} from 'react'

const Hero = () => {
    const [slides, setSlides] = useState([]);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/carusel`);
                setSlides(response.data.data);
            } catch (error) {
                console.error('Slaytlar alınırken hata oluştu:', error);
            }
        };

        fetchSlides();
    }, []);

    const slideTemplate = (slide) => (
        <div className="slide">
            <div className="text-container">
                <h1 className="title">{slide?.title}</h1>
                <p className="description">{slide?.body}</p>
            </div>
            <div className="image-container">
                <img
                    src={`https://api.drnigarguliyeva.az/${slide?.photo}`}
                    alt={slide?.title}
                />
            </div>
        </div>
    );

    return (
        <div className="hero">
            <Carousel
                value={slides}
                numVisible={1}
                numScroll={1}
                itemTemplate={slideTemplate}
                autoplayInterval={5000} // Slaytların her 5 saniyede bir otomatik değişmesi
                showIndicators={false} // Göstergeleri gizle
                showNavigators={false} // Gezinme oklarını gizle
                circular // Sonsuz döngü
            />
        </div>
    );
};

export default Hero;
